module.exports = "<h1>\n  BioGateway RDF Landing pages\n</h1>\n"